import { ScatterPlotChartOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
export const SCATTER_PLOT_INTERACTIVE_CHART_OPTIONS = [
    {
        label: 'Show Legend',
        value: ScatterPlotChartOptionValue.displayLegend,
        selected: false,
    },
    {
        label: 'Show Currency Code in Legend',
        value: ScatterPlotChartOptionValue.displayCurrencyCodeInLegend,
        selected: false,
    },
    {
        label: 'Show X/Y Data in Legend',
        value: ScatterPlotChartOptionValue.displayXYDataInLegend,
        selected: false,
        disabled: false,
    },
    {
        label: 'Show All Currency Codes on Chart',
        value: ScatterPlotChartOptionValue.displayAllCurrencyCodes,
        selected: false,
    },
    {
        label: 'Show All Names on Chart',
        value: ScatterPlotChartOptionValue.displayAllNames,
        selected: false,
    },
    {
        label: 'Show All Dates on Chart',
        value: ScatterPlotChartOptionValue.displayAllDates,
        selected: false,
    },
    {
        label: 'Show All Tickers on Chart',
        value: ScatterPlotChartOptionValue.displayAllTickers,
        selected: false,
    },
    {
        label: 'Show All X/Y Data on Chart',
        value: ScatterPlotChartOptionValue.displayAllXYData,
        selected: false,
    },
    {
        label: 'Show Color Range for Timeseries',
        value: ScatterPlotChartOptionValue.displayColorRange,
        selected: false,
        helpName: 'display_color_range',
    },
    {
        label: 'Use Custom Colors',
        value: ScatterPlotChartOptionValue.useCustomColors,
        selected: false,
        helpName: 'custom_colors_option',
    },
];
// These are the invalid security types that cannot go into the scatter plot tool
export const INVALID_SCATTER_PLOT_SECURITY_TYPES = ['indicator'];
